import { formatPathString } from "./format-path-string";

export const CATEGORY_PAGE_SEGMENTS = ["bestsellers", "new-in"];

export function isSpecialPageSegment(segment: string): boolean {
  return CATEGORY_PAGE_SEGMENTS.includes(segment);
}

export function getLastSegment(pathname: string): string | undefined {
  const segments = pathname.split("/").filter(Boolean);
  return segments[segments.length - 1];
}

export function splitSegments(pathname: string): string[] {
  return pathname.split("/").filter(Boolean);
}

/**
 * Get the Prismic slug from pathname/segments.
 * Always keeps the special segment if present (for Prismic doc lookup).
 */
export function getPrismicSlug(
  pathname: string,
  marketplaceIdentifier: string
): string {
  const segments = splitSegments(pathname);
  return formatPathString("/" + segments.join("/"), marketplaceIdentifier);
}

/**
 * Get the Algolia taxon path, excluding a special segment at the end if present.
 */
export function getTaxonPath(pathname: string): string {
  const segments = splitSegments(pathname);
  const last = segments[segments.length - 1];
  const base = isSpecialPageSegment(last) ? segments.slice(0, -1) : segments;
  return "/" + base.join("/");
}

/**
 * Convenience for the filtered taxon in Algolia's expected format.
 */
export function getTaxonQuery(
  pathname: string,
  marketplaceIdentifier: string
): string {
  const segments = splitSegments(pathname);
  const last = segments[segments.length - 1];
  if (isSpecialPageSegment(last)) {
    return "";
  }
  const taxonPath = getTaxonPath(pathname);
  return formatPathString(taxonPath, marketplaceIdentifier, "algolia-query");
}
